if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      if (document.querySelector('cart-drawer')) {
        if(this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this?.submitButton?.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this?.submitButton?.setAttribute('aria-disabled', true);
      this?.submitButton?.classList.add('loading');


      // Check for set products metafield JSON from data attribute on the form
      let setProducts = null;
      const setProductsAttr = this.form.querySelector('[name="id"]')?.getAttribute('data-set-products');
      if (setProductsAttr) {
        try {
          setProducts = JSON.parse(setProductsAttr);
        } catch (e) { setProducts = null; }
      }

      // If set products exist and is a non-empty array, add all their variants to cart in a single call and SKIP default single product add
      if (Array.isArray(setProducts) && setProducts.length > 0) {
        const items = setProducts.map(p => ({ id: p.variant_id, quantity: 1, properties: { [p.set_group_line_key]: p.main_product} }));
        const configSet = fetchConfig('javascript');
        configSet.headers['X-Requested-With'] = 'XMLHttpRequest';
        configSet.headers['Content-Type'] = 'application/json';
        const payload = { items };
        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
        configSet.body = JSON.stringify(payload);

        try {
          const response = await fetch('/cart/add.js', configSet).then(r => r.json());
          // Optionally handle cart update event here
          if (!response.status) {
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: 'set', cartData: response});
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          } else {
            // Error: update button as sold out
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: 'set', errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            this?.submitButton?.setAttribute('aria-disabled', true);
            if (this?.submitButtonText) this.submitButtonText.textContent = window.variantStrings.soldOut || 'Sold Out';
            this?.submitButton?.classList.add('sold-out');
            this?.submitButton?.setAttribute('disabled', 'disabled');
            this.error = true;
          }
        } catch (e) {
          // Network or JS error: also show sold out
          console.error(e);
          this?.submitButton?.setAttribute('aria-disabled', true);
          if (this?.submitButtonText) this.submitButtonText.textContent = window.variantStrings.soldOut || 'Sold Out';
          this?.submitButton?.classList.add('sold-out');
          this?.submitButton?.setAttribute('disabled', 'disabled');
          this.error = true;
        }
        this?.submitButton?.classList.remove('loading');
        if (this?.cart && this.cart.classList.contains('is-empty')) this?.cart?.classList?.remove('is-empty');
        if (!this.error) this?.submitButton?.removeAttribute('aria-disabled');
        this?.querySelector('.loading-overlay__spinner')?.classList?.add('hidden');
        return; 
      }

      // Default: single product add to cart
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      const variantInputs = this.form.querySelectorAll('[name="set_product_variant"]');

      if (variantInputs.length > 0) {

        // SET PRODUCT LOGIC

        config.headers['Content-Type'] = 'application/json';

        const quantityInput = document.querySelector('[name="quantity"]');
        const mainQty = parseInt(quantityInput?.value || 1);
        const title = document.querySelector('.product__title h1').textContent;

        const variantIds = Array.from(variantInputs).map(input => input.value);
        const lineItemKey = variantInputs[0].dataset.setProductKey || 'Set Group';

        const items = variantIds.map(id => ({
          id: id,
          quantity: mainQty,
          properties: { [lineItemKey]: title }

        }));

        

        config.body = JSON.stringify({
          items,
          sections: this.cart
            ? this.cart.getSectionsToRender().map(section => section.id)
            : [],
          sections_url: window.location.pathname
        });

      } else {

        // NORMAL SHOPIFY PRODUCT LOGIC

      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;
      }
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          const primaryVariantId =
            variantInputs[0]?.value || this.form.querySelector('[name="id"]')?.value || null;
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: primaryVariantId, errors: response.description, message: response.message });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: primaryVariantId, cartData: response });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (!this.submitButton) return;
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    get variantIdInput() {
      return this.form.querySelector('[name=id]');
    }
  });
  document.addEventListener('DOMContentLoaded', () => {
      // Handle included products toggle
      const includedToggle = document.getElementById('includedToggle');
      const includedGrid = document.getElementById('includedGrid');

      if (includedToggle && includedGrid) {
        includedToggle.addEventListener('click', () => {
          includedToggle.classList.toggle('expanded');
          includedGrid.classList.toggle('accordion-enabled');
          includedGrid.classList.toggle('accordion-disabled');
        });
      }
    });
}